// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_gW","advertCardPhoto__image":"c-a_gX"};